export default "__VITE_ASSET__f5ed48ec__"